/* External Imports */
import { Box, Text, useBreakpointValue } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Styles */
import styles from '@lb/Sections/aboutDevi/styles.module.css';

const AboutDeviSlide4 = ({ section }) => {
  return (
    <Box
      background={{
        base: `#000 url(${config.imgPath}/d/46272/1684474049-ib_mob_secion4bg.jpg) no-repeat center top`,
        lg: `#000 url(${config.imgPath}/d/46272/1684474045-ib_secion4bg.jpg) no-repeat center top`,
      }}
      bgPos={{ base: '100%', lg: 'cover' }}
      bgSize={{ base: '100%', lg: '100%' }}
      className={styles.section4Bg}
      overflow="hidden"
      pos="relative"
    >
      <LazyLoadImageComponent
        src={useBreakpointValue({
          base: `${config.imgPath}/d/46272/1684475458-lb_mob_sevika.png`,
          sm: `${config.imgPath}/d/46272/1684473932-lb_sevika.png`,
        })}
        alt="sevika"
        width="auto"
        height="80%"
        pos="absolute"
        bottom="0px"
        right="10px"
        zIndex="2px"
      />
      <LazyLoadImageComponent
        src={useBreakpointValue({
          base: `${config.imgPath}/d/46272/1684477453-lb_mob_trishul.png`,
          sm: `${config.imgPath}/d/46272/1684474092-lb_trishul.png`,
        })}
        alt="lb_trishul"
        width="auto"
        height="98%"
        pos="absolute"
        bottom="0px"
        left="0rem"
      />
      <Box maxW="1200px" mx="auto" display="flex">
        <Box
          width={{ base: '20rem', md: '24rem', lg: '30rem' }}
          textAlign="center"
          pt={{ base: '90vmin', md: '30vmin' }}
          position="relative"
          zIndex="1px"
          pb="1rem"
          display="flex"
          flexDir="column"
          justifyContent={{ base: 'center', lg: 'left' }}
          mx={{ base: 'auto', md: '0' }}
        >
          <Box
            bg="#000"
            borderRadius="100%"
            p="30px"
            background="rgba(0, 0, 0, 0.5)"
            boxShadow="0px 0px 120px 12px #000"
          >
            <Box display="flex" justifyContent="center" pb={4}>
              <svg
                width="22"
                height="18"
                viewBox="0 0 22 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.802814 12.0339C0.802814 13.5905 3.92269 17.1229 4.99851 17.1229C5.75159 17.1229 9.08663 13.5905 9.08663 12.6326C9.08663 11.8543 6.71983 9.04039 5.48263 8.20221C5.59022 5.56792 7.90323 3.29286 9.248 1.67637L7.52669 3.8147e-06C4.29923 2.15533 0.802814 7.66338 0.802814 12.0339ZM12.6368 12.0339C12.6368 13.5905 15.7567 17.1229 16.8325 17.1229C17.5856 17.1229 20.9207 13.5905 20.9207 12.6326C20.9207 11.8543 18.5539 9.04039 17.3167 8.20221C17.4242 5.56792 19.7373 3.29286 21.082 1.67637L19.3607 3.8147e-06C16.1333 2.15533 12.6368 7.66338 12.6368 12.0339Z"
                  fill="white"
                />
              </svg>
            </Box>
            <Text
              color="#F5E576"
              fontWeight="medium"
              fontSize={{ base: '18px', lg: '25px' }}
              mb={4}
            >
              {section?.sectionContent?.[0]?.quote?.replace('- Sadhguru', '')}
            </Text>
            <Box textAlign="center" display="flex" justifyContent="center">
              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1684475419-lb_sadhguru_signature.png`}
                alt="sadhguru_Signature"
                className="section1Animate"
                width={{ base: '107px', lg: '197px' }}
                height={{ base: '62px', lg: '114px' }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide4;
